// @flow
import styled from 'styled-components';

export const TrainTimesList = styled.ul`
  list-style-type: none;
  position: relative;
  padding-left: 12px;
`;

export const TrainTimesListItem = styled.li`
  // Dot
  &:before {
    border: 2px solid var(--color-brand-primary);
    border-radius: 50%;
    content: '';
    display: inline-block;
    height: 8px;
    margin-right: 8px;
    position: relative;
    top: -2px;
    vertical-align: middle;
    width: 8px;
  }

  // Line
  &:after {
    background-color: var(--color-neutral-gray-1);
    content: '';
    display: block;
    height: 40px;
    left: 4px;
    position: relative;
    width: 3px;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`;
